import React, { useState, useEffect } from 'react';
import { mergeClasses } from '@griffel/react';

const UIToggleSwitch = ({ className, value, onChange }) => 
{
	const [isOn, setIsOn] = useState(value);

	useEffect(() => 
	{
		setIsOn(value);
	},
	[value]);

	const handleClick = () => 
	{
		const newState = !isOn;
		setIsOn(newState);
		onChange(newState);
	};

	const toggleClass = mergeClasses('ui-toggle', className);

	return (
		<div className={toggleClass} onClick={handleClick} data-checked={isOn ? 1 : 0}>
			<div className="switch">
				<div className="knob"></div>
			</div>
			<span className="toggle-label">{isOn ? 'ON' : 'OFF'}</span>
		</div>
	);
};

export default UIToggleSwitch;
